'use client'
const ErrorPage = () => {
  return null
}

export default ErrorPage
